import React, { useEffect } from 'react';
import classes from './v2.module.css';

/** A pop-up over the page: title, scrolling body, and a footer for the buttons. Esc or the backdrop closes it. */
export default function Modal({ title, onClose, footer, children, width = 760 }) {
  useEffect(() => {
    const h = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', h);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', h);
      document.body.style.overflow = prev;
    };
  }, [onClose]);
  return (
    // .page carries the colors and fonts; a pop-up opened outside a page (the To-Do list's
    // editor, the header's ADD TO-DO) had none of them and showed see-through.
    <div className={`${classes.page} ${classes.modalBack}`} onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className={classes.modal} style={{ maxWidth: width }} role="dialog" aria-modal="true" aria-label={title}>
        <div className={classes.modalHead}>
          <b>{title}</b>
          <button type="button" className={classes.iconBtn} onClick={onClose} aria-label="Close">
            Close
          </button>
        </div>
        <div className={classes.modalBody}>{children}</div>
        {footer && <div className={classes.modalFoot}>{footer}</div>}
      </div>
    </div>
  );
}
